import {
  createLandingPage,
  getLandingPage,
  GET_LANDING_PAGE_SUCCESS,
} from 'actions/landingPage'
import Spinner from 'components/Spinner'

import useCurrentMerchant from 'hooks/useCurrentMerchant'
import useDispatch from 'hooks/useDispatch'
import React, { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap-five'
import { useSelector } from 'react-redux'
import { selectApp } from 'selectors/app'
import ContentTabsLayout from './ContentTabsLayout'

// Direct copy-paste of enum from Content/index.tsx (AppNavigation tabs moved to AppNavigation/Tabs.tsx)
export enum Tabs {
  MenuCategory = 'menu_category',
  HeroCarousel = 'hero_carousel',
  ContentBlocks = 'content_blocks',
  FixedButtons = 'fixed_buttons',
  WebHeroImage = 'web_hero_image',
  AlertBanner = 'alert_banner',
  CustomLinks = 'custom_links',
}

type Props = {
  children: React.ReactNode
}

// New component meant to replace /Content/index.tsx
// This is a temporary hack to allow new Content pages to have independent navigation,
// to be able to bypass the amount of coupling & insane architecture of the Content page
const ContentLayout: React.FC<Props> = ({ children }) => {
  // Direct copy-paste from Content/index.tsx
  const { app_ordering_enabled, branded_app } = useCurrentMerchant() || {}
  const app = useSelector(selectApp)
  const brandedAppAvailable = app?.allow_downloads && branded_app
  const appWithOrdering = app_ordering_enabled && brandedAppAvailable
  const [isLoading, setIsLoading] = useState(!appWithOrdering)

  const dispatch = useDispatch()
  const appId = app?.id

  useEffect(() => {
    async function fetchData() {
      const response = await dispatch(getLandingPage(appId))
      if (response.type !== GET_LANDING_PAGE_SUCCESS) {
        await dispatch(createLandingPage(appId))
      }
      setIsLoading(false)
    }

    if (!appWithOrdering && appId) {
      fetchData()
    }
  }, [dispatch, appWithOrdering, appId])

  return (
    <Row className="mt-m">
      <ContentTabsLayout />

      <Col className="pl-xl" md="9">
        {/* Pure React Router - no Bootstrap Tab interference */}
        <div
          className="grey-05-bkg"
          style={{ minHeight: '500px', padding: '20px' }}
        >
          <Spinner
            className="text-center margin-top-huge"
            size="4x"
            isLoading={isLoading}
          >
            {children}
          </Spinner>
        </div>
      </Col>
    </Row>
  )
}

export default ContentLayout
